import React from "react";
import { useTranslation } from "react-i18next";
import { Team, Tournament } from "@gp/models";
import { StreakStat } from "@data-types/sport-stats/SportStatsTypes";
import TeamIcon from "@components/icons/TeamIcon";
import { renderStreak } from "./renderStreak";

export const StreakSection = (props: {
	title: string;
	data: StreakStat[];
	tournament: Tournament | undefined;
	homeTeam: Team | undefined;
	awayTeam: Team | undefined;
}) => {
	if (!props.data) return null;

	const { t } = useTranslation();

	const homeIcon = (
		<TeamIcon
			showCountryFlag={props.tournament?.showCountryFlag}
			flagCode={props.homeTeam?.countryCode}
			jerseyTypeAbrv={props.homeTeam?.jerseyTypeAbrv}
			opponentFlagCode={props.awayTeam?.countryCode}
			opponentJerseyTypeAbrv={props.awayTeam?.jerseyTypeAbrv}
			className="u-icon u-icon--base u-mar--right--2"
		/>
	);

	const awayIcon = (
		<TeamIcon
			showCountryFlag={props.tournament?.showCountryFlag}
			flagCode={props.awayTeam?.countryCode}
			jerseyTypeAbrv={props.awayTeam?.jerseyTypeAbrv}
			opponentFlagCode={props.homeTeam?.countryCode}
			opponentJerseyTypeAbrv={props.homeTeam?.jerseyTypeAbrv}
			className="u-icon u-icon--base u-mar--right--2"
		/>
	);

	return (
		<div className="card card--raised card--stats">
			<div className="card__header card--stats__header">
				<div className="card__title card__title--base card--stats__heading">
					{props.title}
				</div>
			</div>

			<div className="card--stats__body">
				{props.data.map((item, index) => {
					const icon = item.team === "home" ? homeIcon : awayIcon;
					const mainTeam =
						item.team === "home" ? props.homeTeam : props.awayTeam;

					if (item.team === "both") {
						return [
							renderStreak(
								props.homeTeam,
								t("EVENT.OFFER.COMPETITOR_HOME"),
								homeIcon,
								item,
								index,
								t
							),
							renderStreak(
								props.awayTeam,
								t("EVENT.OFFER.COMPETITOR_AWAY"),
								awayIcon,
								item,
								index,
								t
							),
						];
					}

					return renderStreak(
						mainTeam,
						item.team === "home"
							? t("EVENT.OFFER.COMPETITOR_HOME")
							: t("EVENT.OFFER.COMPETITOR_AWAY"),
						icon,
						item,
						index,
						t
					);
				})}
			</div>
		</div>
	);
};
